<template>
  <div>
    <header class="custom-shape-divider-top-1664458927">
      <svg
        data-name="Layer 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1200 120"
        preserveAspectRatio="none"
      >
        <path
          d="M0,0V46.29c47.79,22.2,103.59,32.17,158,28,70.36-5.37,136.33-33.31,206.8-37.5C438.64,32.43,512.34,53.67,583,72.05c69.27,18,138.3,24.88,209.4,13.08,36.15-6,69.85-17.84,104.45-29.34C989.49,25,1113-14.29,1200,52.47V0Z"
          opacity=".25"
          class="shape-fill"
        ></path>
        <path
          d="M0,0V15.81C13,36.92,27.64,56.86,47.69,72.05,99.41,111.27,165,111,224.58,91.58c31.15-10.15,60.09-26.07,89.67-39.8,40.92-19,84.73-46,130.83-49.67,36.26-2.85,70.9,9.42,98.6,31.56,31.77,25.39,62.32,62,103.63,73,40.44,10.79,81.35-6.69,119.13-24.28s75.16-39,116.92-43.05c59.73-5.85,113.28,22.88,168.9,38.84,30.2,8.66,59,6.17,87.09-7.5,22.43-10.89,48-26.93,60.65-49.24V0Z"
          opacity=".5"
          class="shape-fill"
        ></path>
        <path
          d="M0,0V5.63C149.93,59,314.09,71.32,475.83,42.57c43-7.64,84.23-20.12,127.61-26.46,59-8.63,112.48,12.24,165.56,35.4C827.93,77.22,886,95.24,951.2,90c86.53-7,172.46-45.71,248.8-84.81V0Z"
          class="shape-fill"
        ></path>
      </svg>
      <img
        class="header-img hidden-sm-and-down"
        src="Images/back.png"
        alt="back"
      />
      <v-container class="p-6">
        <h1 class="text-h2 font-weight-bold">Get Our Service</h1>
        <h1 class="mb-8 text-h2 font-weight-bold">Here</h1>
        <p class="mb-5">
          corrupti consectetur. Earum ratione hic voluptatibus eum libero
          repellendus
        </p>
        <p class="mb-5">
          Dolor nostrum doloremque quos repellat omnis aspernatur
        </p>
        <p class="mb-5">
          Aamet consectetur adipisicing elit. Etratione, quidem
        </p>
        <v-btn class="text-uppercase bg-info">Get Started</v-btn>
      </v-container>
    </header>
    <main>
      <!-- Get Started -->
      <div id="getstart" class="d-flex justify-center my-5">
        <div class="design1 bg-primary"></div>
        <div class="design2 bg-info"></div>
      </div>
      <h1 class="text-center">How To Get Started</h1>
      <v-container>
        <v-row>
          <v-col cols="12" lg='3' sm="6" md="6">
            <v-card class="reveal pa-2" :class="{'fade-left': scrollPosition > 100}" outlined tile>
              <v-img src="Images/img2.png"></v-img>
              <v-card-title class="text-center"
                >Create Your <br />
                Account</v-card-title
              >

              <v-card-text class="text-center">
                Lorem ipsum dolor sit amet consectetur adipisicing elit.
                Voluptatem dicta exercitationem quisquam
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" lg='3' sm="6" md="6">
            <v-card class="reveal pa-2" :class="{'fade-left': scrollPosition > 100}"  outlined tile>
              <v-img src="Images/img3.png"></v-img>
              <v-card-title class="text-center"
                >Plan Your <br />
                Journey</v-card-title
              >
              <v-card-text class="text-center">
                Lorem ipsum dolor sit amet consectetur adipisicing elit.
                Voluptatem dicta exercitationem quisquam
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" lg='3' sm="6" md="6">
            <v-card class="pa-2" :class="{'fade-right': scrollPosition > 100}" outlined tile>
              <v-img src="Images/img4.png"></v-img>
              <v-card-title class="text-center"
                >Meet Your <br />
                Driver</v-card-title
              >
              <v-card-text class="text-center">
                Lorem ipsum dolor sit amet consectetur adipisicing elit.
                Voluptatem dicta exercitationem quisquam
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" lg='3' sm="6" md="6">
            <v-card class="pa-2" :class="{'fade-right': scrollPosition > 100}" outlined tile>
              <v-img class="mb-8" src="Images/img5.png"></v-img>
              <v-card-title class="text-center"
                >Enjoy Your <br />
                Journey</v-card-title
              >
              <v-card-text class="text-center">
                Lorem ipsum dolor sit amet consectetur adipisicing elit.
                Voluptatem dicta exercitationem quisquam
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>

      <!-- Drive -->
      <v-container id="service" fluid class="my-10">
        <h1 class="text-center">Our Services</h1>

        <v-container class="drive-div">
          <v-row class="py-12">

            <v-col cols="12" lg="8" md="8" sm="12" :class="{'fade-left': scrollPosition > 800}">
              <div class="d-flex my-5">
                <div class="design1 bg-primary"></div>
                <div class="design2 bg-info"></div>
              </div>
              <h1 class="text-fontColorHeading">Gives You</h1>
              <h1 class="text-fontColorHeading">Full Comfort</h1>
              <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Quas
                voluptate ipsum, reprehenderit numquam ullam nobis eveniet odit
                velit voluptates nisi itaque, possimus quibusdam perferendis
                vero natus, mollitia hic nemo corrupti.
              </p>
              <p class="text-body-1 my-5">
                voluptatem voluptas cupiditate iusto
              </p>
              <h3>hic nemo corrupti</h3>
            </v-col>

            <v-col cols="12" lg="4" md="4" sm="12" :class="{'fade-right': scrollPosition > 800}">
              <img class="car-image" src="Images/car.png" alt="car" />
            </v-col>

          </v-row>
          <v-row class="py-12">

            <v-col cols="12" lg="4" md="4" sm="12" :class="{'fade-left': scrollPosition > 1200}">
              <img class="car-image" src="Images/location.png" alt="car" />
            </v-col>

            <v-col cols="12" lg="8" md="8" sm="12" class="ps-16" :class="{'fade-right': scrollPosition > 1200}">
              <div class="d-flex my-5">
                <div class="design1 bg-primary"></div>
                <div class="design2 bg-info"></div>
              </div>
              <h1 class="text-fontColorHeading">Reach Your</h1>
              <h1 class="text-fontColorHeading">Destination</h1>
              <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Quas
                voluptate ipsum, reprehenderit numquam ullam nobis eveniet odit
                velit voluptates nisi itaque, possimus quibusdam perferendis
                vero natus, mollitia hic nemo corrupti.
              </p>
              <p class="text-body-1 my-5">
                voluptatem voluptas cupiditate iusto
              </p>
              <h3>hic nemo corrupti</h3>
            </v-col>

          </v-row>

          <v-row id="contactus" class="py-12">
            <v-col cols="12" lg="8" md="8" sm="12" :class="{'fade-left': scrollPosition > 1800}">
              <div class="d-flex my-5">
                <div class="design1 bg-primary"></div>
                <div class="design2 bg-info"></div>
              </div>
              <h1 class="text-fontColorHeading">Get Our App</h1>
              <h3>
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Quas
                voluptate ipsum, reprehenderit numquam ullam nobis eveniet odit
                velit voluptates nisi itaque,
              </h3>
              <v-btn class="bg-black mt-12 me-4 button-play">
                <img
                  class=""
                  src="https://img.icons8.com/color/48/000000/google-play.png"
                />
                <v-btn-text>Get on Play Store</v-btn-text>
              </v-btn>
              <v-btn class="bg-black mt-12 button-play">
                <v-icon class="me-2 text-h3">mdi-apple</v-icon>Get on Apple
                Store</v-btn
              >
            </v-col>

            <v-col cols="12" lg="4" md="4" sm="12" :class="{'fade-right': scrollPosition > 1800}">
              <img class="car-image" src="Images/getApp.png" alt="car" />
            </v-col>

          </v-row>
        </v-container>
      </v-container>

      <v-container>
        <v-row :class="{'fade-left': scrollPosition > 2222}">
          <v-col cols="12" sm="6">
            <v-card class="card-style py-5 px-4" outlined tile>
              <v-row>
                <v-col cols="12" lg="10">
                  <h2 class="text-fontColorHeading mb-3">Start Your</h2>
                  <h2 class="text-fontColorHeading mb-3">Work Comfortably</h2>
                  <p class="font-weight-bold">
                    Lorem ipsum dolor sit amet consectetur, adipisicing elit.
                  </p>
                  <div class="d-flex my-5">
                    <div class="design1 bg-primary"></div>
                    <div class="design2 bg-info"></div>
                  </div>
                </v-col>
                <v-col cols="12" lg="2" class="text-center">
                  <v-icon class="text-secondary text-h3 my-lg-15"
                    >mdi-tag-arrow-down-outline</v-icon
                  >
                </v-col>
              </v-row>
            </v-card>
          </v-col>
          <v-col cols="12" sm="6">
            <v-card class="card-style py-5 px-4" outlined tile>
              <v-row>
                <v-col cols="12" lg="10">
                  <h2 class="text-fontColorHeading mb-3">Start Your</h2>
                  <h2 class="text-fontColorHeading mb-3">Work Comfortably</h2>
                  <p class="font-weight-bold">
                    Lorem ipsum dolor sit amet consectetur, adipisicing elit.
                  </p>
                  <div class="d-flex my-5">
                    <div class="design1 bg-primary"></div>
                    <div class="design2 bg-info"></div>
                  </div>
                </v-col>
                <v-col cols="12" lg="2" class="text-center">
                  <v-icon class="text-secondary text-h3 my-lg-15"
                    >mdi-tag-arrow-down-outline</v-icon
                  >
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </main>
  </div>
</template>

<script>
export default {
  name: "HomeComp",
  data() {
    return {
      show: false,
      scrollPosition: null,
    };
  },
  methods: {
    updateOnScroll(){
      this.scrollPosition = window.scrollY;
    }
  },
  mounted(){
    window.addEventListener("scroll", this.updateOnScroll)
  }
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Abril+Fatface&family=Inter+Tight&family=Noto+Sans+Mono:wght@600&family=Righteous&display=swap");

.drive-div h1 {
  font-family: "Righteous", cursive;
  margin-bottom: 10px;
}
.card-style h1 {
  font-family: "Righteous", cursive;
}
.card-style p {
  font-family: "Inter Tight", sans-serif;
}
.drive-div p {
  font-family: "Noto Sans Mono", monospace;
}
.header-img {
  float: right;
  margin-top: -160px;
}
.car-image {
  width: 400px;
}
.design1 {
  width: 10px;
  height: 10px;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
}
.design2 {
  width: 80px;
  height: 10px;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
}
.button-play {
  height: 50px;
}
.fade-left{
  animation: fade-left 1s ease-in;
}
@keyframes fade-left {
  0% {
    transform: translateX(-100px);
    opacity: 0;
  }
  100% {
    transform: translateX(0);
    opacity: 1;
  }
}
.fade-right{
  animation: fade-right 1s ease-in;
}
@keyframes fade-right {
  0% {
    transform: translateX(100px);
    opacity: 0;
  }
  100% {
    transform: translateX(0);
    opacity: 1;
  }
}
.custom-shape-divider-top-1664458927 {
  width: 100%;
  overflow: hidden;
  line-height: 0;
  margin-top: -64px;
}

.custom-shape-divider-top-1664458927 svg {
  position: relative;
  display: block;
  width: calc(110% + 1.3px);
  height: 365px;
  transform: rotateY(180deg);
}

.custom-shape-divider-top-1664458927 .shape-fill {
  fill: #442697;
}
</style>